// extracted by mini-css-extract-plugin
export default {"container":"WC-z","dimension":"XC-z","dimensionLabels":"YC-z"};